import { withNamespaces } from 'react-i18next';
import { UncontrolledTooltip } from 'reactstrap';

export const ACTIVATED_FUNCTION_ACTIONS = {
    TOGGLE_FLAG: 'toggleFlag',
};

export const ACTIVATED_FUNCTION_DEFINITIONS = [
    {
        key: 'CS',
        title: 'Compliance Screening',
    },
    {
        key: 'RDM',
        title: 'Risk Decision Matrix',
    },
    {
        key: 'CM',
        title: 'Compliance Monitoring',
    },
    {
        key: 'DNB',
        title: 'Dun & Bradstreet',
    },
    {
        key: 'EGD',
        title: 'EUDR Geodata',
    },
    {
        key: 'ANM',
        title: 'Adverse News Monitoring',
        action: ACTIVATED_FUNCTION_ACTIONS.TOGGLE_FLAG,
    },
];

const tooltipIdFor = (idPrefix, key) => (
    `${idPrefix}-${key}`.replace(/[^A-Za-z0-9_-]/g, '')
);

const ActivatedFunctions = ({
    functions,
    idPrefix,
    actions = {},
    pendingKey = null,
    t,
}) => {
    if (!functions || typeof functions !== 'object' || Array.isArray(functions)) {
        return '---';
    }

    const knownKeys = ACTIVATED_FUNCTION_DEFINITIONS.map((item) => item.key);
    const items = [
        ...ACTIVATED_FUNCTION_DEFINITIONS.filter((item) => (
            Object.prototype.hasOwnProperty.call(functions, item.key)
        )),
        ...Object.keys(functions)
            .filter((key) => !knownKeys.includes(key))
            .map((key) => ({
                key,
                title: key,
            })),
    ];

    if (!items.length) {
        return '---';
    }

    const columnCount = Math.min(3, Math.ceil(items.length / 2));

    return (
        <span
            className="activated-functions"
            style={{ gridTemplateColumns: `repeat(${columnCount}, max-content)` }}
        >
            {items.map((item) => {
                const isActive = functions[item.key] === true;
                const onAction = item.action ? actions[item.key] : null;
                const isClickable = typeof onAction === 'function';
                const isPending = pendingKey === item.key;
                const tooltipId = tooltipIdFor(idPrefix, item.key);
                const className = [
                    'activated-functions__chip',
                    isActive ? 'is-active' : '',
                    isClickable ? 'is-interactive' : '',
                    isPending ? 'is-pending' : '',
                ].filter(Boolean).join(' ');
                const chip = isClickable ? (
                    <button
                        id={tooltipId}
                        type="button"
                        className={className}
                        disabled={isPending}
                        aria-pressed={isActive}
                        onClick={(event) => {
                            event.preventDefault();
                            event.stopPropagation();
                            onAction(item, isActive);
                        }}
                    >
                        {item.key}
                    </button>
                ) : (
                    <span
                        id={tooltipId}
                        className={className}
                    >
                        {item.key}
                    </span>
                );

                return (
                    <span key={item.key}>
                        {chip}
                        <UncontrolledTooltip
                            placement="top"
                            target={tooltipId}
                        >
                            {`${t(item.title)} — ${t(isActive ? 'Active' : 'Not active')}`}
                        </UncontrolledTooltip>
                    </span>
                );
            })}
        </span>
    );
};

export default withNamespaces()(ActivatedFunctions);
